import React from "react";
import {
  Box,
  Container,
  Typography,
  Stack,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function Support() {
  return (
    <Box component="main" sx={{ py: 8, background: "#fbfcfe" }}>
      <Container maxWidth="md">
        <Stack spacing={3}>
          <Typography variant="h4" fontWeight={800}>
            Support Center — FentrixBank
          </Typography>

          <Typography>
            Browse answers to common questions or open a ticket for personalized help.
          </Typography>

          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography fontWeight={700}>
                Account verification & KYC
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Typical verification requires a government ID, proof of address (less than
                3 months old), and a selfie. Processing times vary by jurisdiction.
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography fontWeight={700}>Troubleshooting login</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                If you can't log in, confirm your email and password, clear cookies,
                or use "Forgot password" to reset. If MFA issues persist, contact Support.
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography fontWeight={700}>Transaction delays</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Some interbank or cross-border transfers may take additional time due to
                partners or compliance checks. Check transaction status in your activity log.
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Typography variant="h6" fontWeight={700}>
            Other ways to get help
          </Typography>

          <List>
            <ListItem>
              <ListItemText primary="Email: support@fentrixbank.com" />
            </ListItem>
            <ListItem>
              <ListItemText primary="Support ticket: Open via the dashboard" />
            </ListItem>
            <ListItem>
              <ListItemText primary="For security incidents: Call our emergency line" />
            </ListItem>
          </List>

          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <HelpOutlineIcon fontSize="large" color="primary" />
            <Typography color="text.secondary">
              If you need immediate assistance, open a ticket and include relevant
              transaction IDs or screenshots.
            </Typography>
          </Box>
        </Stack>
      </Container>
    </Box>
  );
}